import React from 'react'
import { Button, Layout, Dropdown, Avatar, Image } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined, UserOutlined } from '@ant-design/icons';

import './index.css'
import { useDispatch } from "react-redux";
import { collapseMenu } from '../../store/reducers/tab'
import { useNavigate } from 'react-router-dom'


const { Header } = Layout

const CommonHeader = ({ collapsed }) => {
  const dispatch = useDispatch()
  const setCollapsed = () => {
    dispatch(collapseMenu())
  }
  const navigate = useNavigate()
  const items = [
    {
      key: '1',
      label: (
        <a onClick={() => logout(!collapsed)} target="_blank" rel="noopener noreferrer" >
          Logout
        </a>
      ),
    }
  ]
  // 登出
  const logout = () => {
    localStorage.removeItem('token')
    navigate('/login')
  }
  return (
    <Header className="header-container">
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: '16px',
          width: 64,
          height: 32,
          backgroundColor: '#fff'
        }}
      />

      {/* <Image
        src={require('../../assets/images/static16.png')}
        alt="Description"
        style={{ width: 200, height: 55 }}
      /> */}
      <Dropdown
        menu={{ items }}
      >
        <a onClick={(e) => e.preventDefault()}>
          {/* <Avatar size={36} src={<img src={require("../../assets/images/user.png")} />} /> */}
          <Avatar icon={<UserOutlined />} size={36} />
        </a>
      </Dropdown>
    </Header>
  )
}

export default CommonHeader